import React, { createContext, useContext, useEffect, useState } from "react";
import api, { setAuthToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=authed
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (alive) setUser(data);
      } catch {
        if (alive) setUser(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const login = async (email, password, remember = false) => {
    setError("");
    const { data } = await api.post("/auth/login", { email, password, remember });
    if (data.token) setAuthToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const setSession = (u, token) => {
    if (token) setAuthToken(token);
    setUser(u);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setAuthToken(null);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, error, setError, login, logout, setSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
